import { STUDIO } from "../../data";

export const Footer = () => {
  const go = (id) => {
    const el = document.getElementById(id);
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -20 });
    else el?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#EBE7DB] pt-20 pb-10 overflow-hidden" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-10 pb-16 border-b border-[#D5CFC1]">
          <div className="lg:col-span-6">
            <p className="text-xs uppercase tracking-[0.28em] text-[#7A766C] mb-4">{STUDIO.tagline}</p>
            <p className="font-serif text-lg text-[#4A4843] max-w-sm leading-relaxed">
              Tailored facials, brows & considered lash artistry, one appointment at a time.
            </p>
          </div>
          <div className="lg:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] text-[#7A766C] mb-4">Explore</p>
            <ul className="space-y-2 text-[#1A1A18]">
              {["about", "services", "contact"].map((id) => (
                <li key={id}>
                  <button onClick={() => go(id)} className="capitalize hover:text-[#3E3B32] transition-colors" data-testid={`footer-nav-${id}`}>
                    {id === "contact" ? "Book" : id}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] text-[#7A766C] mb-4">Contact</p>
            <ul className="space-y-2 text-[#1A1A18]">
              <li><a href={`tel:${STUDIO.phone}`} className="hover:text-[#3E3B32] transition-colors">{STUDIO.phoneDisplay}</a></li>
              <li><a href={STUDIO.instagramUrl} target="_blank" rel="noreferrer" className="hover:text-[#3E3B32] transition-colors">{STUDIO.instagram}</a></li>
              <li><a href={`mailto:${STUDIO.email}`} className="hover:text-[#3E3B32] transition-colors break-all">{STUDIO.email}</a></li>
              <li className="text-[#7A766C] pt-1">{STUDIO.address}</li>
              <li className="text-[#7A766C]">Mon–Sun · 10AM–8PM · By appointment</li>
            </ul>
          </div>
        </div>

        <h2 className="font-serif font-light text-[26vw] sm:text-[22vw] lg:text-[19vw] leading-[0.8] tracking-tight text-[#1A1A18] pt-10 select-none">
          Sové<span className="text-[#B7B0A0]">.</span>
        </h2>

        <div className="flex flex-col sm:flex-row justify-between gap-3 mt-8 text-xs text-[#7A766C]">
          <p>© {new Date().getFullYear()} {STUDIO.full}. All rights reserved.</p>
          <p>{STUDIO.location}</p>
        </div>
      </div>
    </footer>
  );
};
